import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule} from "@angular/forms";
import {Subscription} from "rxjs";
import {SharedModule} from "../../../shared/shared.module";

@Component({
  selector: 'app-select',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    NgForOf,
    SharedModule,
    NgOptimizedImage,
  ],
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() options: { value: string | undefined | null, label?: string, labelKey: string }[] = [];
  @Input() label: string = '';

  public control = new FormControl();
  public onChange: (value: string) => void = () => {};
  public onTouched: () => void = () => {};
  private subscriptions: Subscription[] = [];

  constructor() {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.control.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: string): void {
    this.control.setValue(value);
  }
}
